/*
  Product page thumbnail rail.

  The thumbs are real anchors — href="#CasaltaMedia-<id>" — so that with JS off
  they still jump to their image. The cost is that every click is a hash
  navigation, and every hash navigation pushes a history entry. Clicking four
  thumbs and pressing Back then walked back through the four images instead of
  leaving the product page, which reads as the button being broken.

  So: intercept, scroll to the same element ourselves, and add nothing to
  history. The URL is left alone rather than rewritten with replaceState — a
  bare product URL is the one worth copying out of the address bar, and the
  hash was never used to deep-link an image.

  scrollIntoView() with no argument, deliberately: scroll-behavior: smooth is
  already declared in casalta-dawn-contract.css, so the default inherits the
  motion the anchor jump had and this stays a behaviour change, not a feel one.

  Lives in its own asset rather than the section's javascript block, for the
  reason recorded in the spec: section JS only RUNS for sections rendered on
  the page.
*/
(function () {
  const rail = document.querySelector('[data-product-thumbs]');
  if (!rail) return;

  rail.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    /* Modified clicks are the visitor asking the browser for something else —
       a new tab, a download. Leave them to it. */
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const target = document.getElementById(id);

    /* No target means something has changed the figure ids. Fall through to
       the native jump rather than swallowing the click. */
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView();
  });
})();
